import { FC } from 'react';
import { roleApi } from '../../api/role.api';
import RoleForm from './RoleForm';

const RolesForm: FC = () => {
  return (
    <>
      <RoleForm roleGroup="agent" />
      <RoleForm roleGroup="vendor" />
    </>    
  );
}

export default RolesForm;
